// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsWrapper__GjOI6rATAi{display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr}`, "",{"version":3,"sources":["webpack://./src/assets/components/settings/components/sections/satisfaction/components/EmailCSAT/EmailPage/index.module.scss"],"names":[],"mappings":"AAAA,yBACE,YAAA,CACA,yBAAA,CACA,2BAAA","sourcesContent":[".tabsWrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsWrapper": `tabsWrapper__GjOI6rATAi`
};
export default ___CSS_LOADER_EXPORT___;
